export default "__VITE_ASSET__3cc1pfbj__"